import React, { useState, useRef } from 'react';
import { FaPhone, FaMapMarkerAlt, FaInstagram, FaFacebook, FaTiktok } from 'react-icons/fa';

export default function Contacto() {
  const [formStatus, setFormStatus] = useState('');
  const [statusType, setStatusType] = useState('success');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const formRef = useRef(null);

const handleSubmit = (e) => {
  e.preventDefault();
  const form = e.target;

  const name = form.name.value.trim();
  const phone = form.phone.value.trim();
  const messageText = form.message.value.trim();
  const phoneRegex = /^[0-9\+\s\-()]{7,20}$/;

  if (!name || !phone || !messageText) {
    setFormStatus("Todos los campos son obligatorios.");
    setStatusType("error");
    scrollToForm();
    setTimeout(() => setFormStatus(''), 5000);
    return;
  }

  if (!phoneRegex.test(phone)) {
    setFormStatus("El formato del teléfono no es válido.");
    setStatusType("error");
    scrollToForm();
    setTimeout(() => setFormStatus(''), 5000);
    return;
  }

  setIsSubmitting(true);

  const htmlContent = `
    <div style="font-family: Arial, sans-serif; color: #333;">
      <div style="text-align: center; margin-bottom: 20px;">
        <img src="https://belutours.com/assets/belu.webp" alt="Belu Tours" style="width: 120px; border-radius: 8px;" />
        <h2 style="color: #B49A56;">Nueva consulta desde el sitio</h2>
      </div>
      <table style="width: 100%; border-collapse: collapse;">
        <tr><td style="padding: 6px;"><strong>Nombre:</strong></td><td>${name}</td></tr>
        <tr><td style="padding: 6px;"><strong>Teléfono:</strong></td><td>${phone}</td></tr>
        <tr><td style="padding: 6px;"><strong>Mensaje:</strong></td><td>${messageText}</td></tr>
      </table>
      <p style="font-size: 12px; color: #777;">Belu Tours - <a href="https://www.belutours.com">www.belutours.com</a></p>
    </div>
  `;

  fetch("https://formsubmit.co/ajax/belutours@gmail.com", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
    },
    body: JSON.stringify({
      _subject: "Consulta desde formulario web Belu Tours",
      _template: "table",
      //html: htmlContent,  // 👈 este es el truco
      name,
      phone,
      message: messageText // lo dejamos igual para que no bloquee
    }),
  })
    .then(() => {
      setFormStatus("Mensaje enviado con éxito");
      setStatusType("success");
      form.reset();
      scrollToForm();
      setTimeout(() => setFormStatus(''), 5000);
    })
    .catch(() => {
      setFormStatus("Ocurrió un error. Intentalo más tarde.");
      setStatusType("error");
      scrollToForm();
      setTimeout(() => setFormStatus(''), 5000);
    })
    .finally(() => {
      setIsSubmitting(false);
    });
};



  const scrollToForm = () => {
    if (formRef.current) {
      formRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="contacto" className="py-12 bg-white relative overflow-hidden" aria-labelledby="contacto-title">
      <div className="text-center mb-10">
        <h2 id="contacto-title" className="text-3xl font-bold text-[#B49A56] mb-6">CONTACTO</h2>
        <p className="text-gray-700 text-base sm:text-lg mt-2">
          ¿List@ para tu próxima aventura? Enviame un mensaje y empecemos a planear 🛫✨
        </p>
      </div>

      <div className="container mx-auto px-4 flex flex-col lg:flex-row items-start justify-center gap-12">
        <div className="w-full lg:w-1/2">
          <form
            onSubmit={handleSubmit}
            ref={formRef}
            className="bg-white shadow-md rounded-lg p-6 relative z-10"
            style={{ border: '2px solid #B49A56', borderRadius: '8px' }}
            noValidate
          >
            <h3 className="text-[#B49A56] font-semibold mb-4 text-lg">Escribinos</h3>
            <input type="hidden" name="_template" value="table" />
            <input type="hidden" name="_subject" value="Consulta desde formulario web Belu Tours" />
            <label htmlFor="name" className="block text-sm text-gray-600 mb-1">Nombre y Apellido</label>
            <input
              type="text"
              name="name"
              id="name"
              placeholder="Nombre y Apellido"
              required
              autoComplete="name"
              className="w-full p-2 mb-3 border border-gray-300 rounded"
            />

            <label htmlFor="phone" className="block text-sm text-gray-600 mb-1">Teléfono</label>
            <input
              type="text"
              name="phone"
              id="phone"
              placeholder="Teléfono"
              required
              autoComplete="tel"
              className="w-full p-2 mb-3 border border-gray-300 rounded"
            />

            <label htmlFor="message" className="block text-sm text-gray-600 mb-1">Mensaje</label>
            <textarea
              name="message"
              id="message"
              placeholder="Mensaje"
              rows="4"
              required
              className="w-full p-2 mb-3 border border-gray-300 rounded"
            ></textarea>

            <button
              type="submit"
              disabled={isSubmitting}
              className={`bg-[#B49A56] text-white px-4 py-2 rounded transition-all text-base ${isSubmitting ? 'opacity-50 cursor-not-allowed' : 'hover:bg-[#9c8448]'}`}
            >
              {isSubmitting ? 'Enviando...' : 'Enviar'}
            </button>
            {formStatus && (
              <div className={`mt-3 text-sm flex items-center gap-2 transition-opacity duration-300 ${statusType === 'success' ? 'text-green-600' : 'text-red-600'}`}>
                <span>{statusType === 'success' ? '✔️' : '❌'}</span>
                <span>{formStatus}</span>
              </div>
            )}
          </form>
        </div>

        <div className="hidden lg:block h-80 w-px bg-[#B49A56] rounded-full mt-8"></div>

        <div className="w-full lg:w-1/2 flex flex-col justify-center gap-6 text-[#B49A56] text-lg mt-8">
          <div className="flex items-center gap-3">
            <FaPhone className="text-xl" />
            <span>+54 9 2616 38-8375</span>
          </div>
          <div className="flex items-center gap-6 text-2xl">
            
              <a
              href="https://instagram.com/belutours"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Instagram"
              className="hover:scale-110 transition-all"
              >
              <FaInstagram />
            </a>
            <a
            href="https://facebook.com/belutours"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Facebook"
            className="hover:scale-110 transition-all"
          >
            <FaFacebook />
          </a>
            <a
            href="https://www.tiktok.com/@belu.tours"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="TikTok"
            className="hover:scale-110 transition-all"
          >
            <FaTiktok />
          </a>
          </div>
          <div className="flex items-center gap-3">
            <FaMapMarkerAlt className="text-xl" />
            <span>Av España 1340, Piso 12 of 15
            Mendoza, Argentina</span>
          </div>
          <iframe
          title="Ubicación Belu Tours"
          src="https://www.google.com/maps?q=Av.+Espa%C3%B1a+1340,+Mendoza,+Argentina&output=embed"
          width="100%"
          height="200"
          className="self-center"
          style={{ border: '2px solid #B49A56', borderRadius: '8px' }}
          allowFullScreen=""
          loading="lazy"
        ></iframe>
        </div>
      </div>

      

      <div className="mt-10 text-center">
        <img src='/assets/belu.webp' alt="Foto de Belu Villarroel" className="w-20 h-20 rounded-full mx-auto shadow-md"  loading="lazy"/>
        <p className="italic text-[#B49A56] mt-2 text-base sm:text-lg">
          “Te acompaño a vivir una experiencia única y significativa”
        </p>
      </div>
    </section>
  );
}
